import { useTranslation } from 'react-i18next'

import { PureTable } from '../../../../../common/ui/pure-table/pure-table'
import { useGetUsers } from '../../../../../entities/user/hooks/user.hooks'

export const ActiveUsersTable = () => {
  const { t } = useTranslation()
  const { data: users } = useGetUsers()

  const columns = [
    {
      dataIndex: 'email',
      key: 'email',
      title: t('common.email'),
      render: (_: any, record: any) => record.email,
    },
    {
      dataIndex: 'projects',
      key: 'projects',
      title: t('usersPage.projects'),
      render: (_: any, record: any) => 0,
    },
    {
      dataIndex: 'roles',
      key: 'roles',
      title: t('usersPage.roles'),
      render: (_: unknown, record: any) => <span>Roles</span>,
    },
    {
      key: 'actions',
      render: (_: any, record: any) => <span>Deactivate user</span>,
    },
  ]

  return (
    <PureTable
      columns={columns}
      dataSource={users ?? []}
      rowKey="id"
      searchFields={['email']}
      searchPlaceholder={t('usersPage.searchPlaceholder')}
      searchEnabled
    />
  )
}
